module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/natalia-sladewska-584887ef9ec20911af7395c77ad25006.png";